"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientApiVersionRegistry = void 0;
exports.getEndpointVersion = getEndpointVersion;
exports.PatientApiVersionRegistry = [
    { endpoint: 'registerPatient', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'registerEmergency', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'registerUnknown', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'registerNewborn', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'registerCorporate', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'registerReferral', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'updateDemographics', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'updateCoverage', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'grantConsent', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'withdrawConsent', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'mergePatient', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'rollbackMerge', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'searchPatient', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'advancedSearch', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'timeline', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'applyRecordProtection', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'releaseRecordProtection', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'removeRecordProtection', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'resolveIdentity', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
    { endpoint: 'reviewIdentity', version: 'v1', status: 'STABLE', introducedIn: '4C.4' },
];
function getEndpointVersion(endpoint) {
    return exports.PatientApiVersionRegistry.find((entry) => entry.endpoint === endpoint);
}
//# sourceMappingURL=api-version-registry.js.map